import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import SetupGuide from 'cio/models/setup-guide';
import SetupGuideSourcesController from 'cio/pods/setup-guide/sources/controller';

export default class SetupGuideSources extends Route {
  crumb() {
    return {
      name: 'Integrate your data',
      path: 'setup-guide.sources',
      helpQuery: 'Quick start platform overview',
    };
  }

  model() {
    return this.modelFor('setup-guide');
  }

  setupController(controller: SetupGuideSourcesController, model: SetupGuide, transition: Transition) {
    super.setupController(controller, model, transition);

    if (model) {
      controller.set('integrationMethod', model.integrationMethod);
    }
  }

  resetController(controller: SetupGuideSourcesController, isExiting: boolean) {
    if (isExiting) {
      controller.reset();
    }
  }
}
